import React from 'react';
import './News.css';
import {Pagination} from 'antd';
// import "./NearTerm";
// import './NearTerm.css';
import {GetNewList} from "../../api/api";
import VlecImg from '../../component/VlecImg';
import { FormattedMessage } from 'react-intl';

import {connect} from "react-redux"
import actions from "../../store/actions"

 class News extends React.Component {
    state = {
        NewList: [],
        current: null,
        NumberOfPages: {},
    };


    handleBack = (ID) => {
        this.props.history.push("/NearTerm", {ID,});
    };

    onChange = (page) => {
        const params = {
            // "PublishType": 0,
            "status": 1,
            "pageIndex": page,
            "pageSize": 10,
        };

        GetNewList(params).then((response) => {
            this.setState({
                NumberOfPages:  response.DataResult,
                NewList:  response.DataResult.DataList || [],
                current: page,
            });
        })
        document.body.scrollTo(300, 350);
    };

    componentWillMount() {
        const params = {
            // "publishType": 0,
            "status": 1,
            "pageIndex": 1,
            "pageSize": 10,
        };
        GetNewList(params).then((response) => {
            this.setState({
                NumberOfPages:  response.DataResult,
                NewList:  response.DataResult.DataList,
            });
        })

    }


    render() {
     // let NumberOfPages = this.state.NumberOfPages;
     // console.log(this.state.NumberOfPages)
       // let NumberOfPages1 =eval(NumberOfPages);
       let NumberOfPages1=this.state.NumberOfPages;
        return (<div className="insideDiv">
                <div className="center new_center">
                    <div className="titleH4">
                        <h4><FormattedMessage id="intl-news-title"/></h4>
                        <p><FormattedMessage id="intl-news-title1"/></p>
                    </div>
                    {/*图文介绍*/}
                    <div className="newList-dl">
                        {this.state.NewList.map((item) => {
                            return <dl  className="newList-DL" key={item.ID}>
                                <dt>
                                    <VlecImg src={item.imagePath}/>
                                </dt>
                                <dd>
                                    <h4>{this.props.local==='zh'?item.titleCn:item.titleEn}</h4>
                                    <p>{this.props.local==='zh'?item.descCn:item.descEn} </p>
                                    <a className="btn btn-hollow" onClick={() => {
                                        this.handleBack(item.id)
                                    }}><FormattedMessage id="intl-viewdetail"/></a>
                                </dd>
                            </dl>
                        })}
                    </div>
                    {/*分页*/}
                    <div className="paging">
                        <Pagination
                            current={NumberOfPages1.CurrentPageIndex}
                            onChange={this.onChange}
                            pageSize={10}
                            total={NumberOfPages1.TotalItemCount}
                        />
                    </div>

                </div>
            </div>
        )
    }
}
export default connect(state => ({ ...state.Language}), { ...actions.Language})(News)


// WEBPACK FOOTER //
// ./src/containers/News/News.js